import { useEffect } from "react";

interface VisaPaymentFormProps {
  url: string;
  onSuccess: () => void;
  onFail: () => void;
}
export default function VisaPaymentForm({
  url,
  onSuccess,
  onFail,
}: VisaPaymentFormProps) {
  useEffect(() => {
    function handleMessage(event: MessageEvent) {
      const data =
        typeof event.data === "string" ? JSON.parse(event.data) : event.data;

      if (data.message === "paymentChannel") {
        if (data.status === "failed") {
          onFail();
        } else {
          onSuccess();
        }
      }
    }
    window.addEventListener("message", handleMessage);
  }, []);
  return (
    <div
      className="fixed inset-0 bg-opacity-50 flex justify-center items-center z-50"
      // ignore clicks outside
      onClick={(e) => e.stopPropagation()}
    >
      <div className="bg-white w-11/12 md:w-3/4 h-3/4 rounded-xl shadow-lg flex flex-col">
        {/* No close button */}
        <iframe
          src={url}
          className="w-full h-full rounded-xl"
          title="Payment"
        ></iframe>
      </div>
    </div>
  );
}
